import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { DialectComponent } from './dialect.component';
import { DialectMenuComponent } from './dialect-menu/dialect-menu.component';
import { DialectRegionComponent } from './dialect-region/dialect-region.component';
import { DialectStoryComponent } from './dialect-story/dialect-story.component';
import {DialectListPageComponent} from "./dialect-list-page/dialect-list-page.component";

const childRoutes: Routes = [
  {
    path: '',
    redirectTo: 'menu',
    pathMatch: 'full',
  },
  {
    path: 'menu',
    component: DialectMenuComponent,
  },
  {
    path: 'region',
    component: DialectRegionComponent,
  },
  {
    path: 'story',
    component: DialectStoryComponent,
  },
];


const routes: Routes = [
  {
    path: 'dialect',
    component: DialectComponent,
    children: childRoutes,
  },
  {
    path: 'dialect-list/:type',
    component: DialectListPageComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
  ],
})
export class DialectRoutingModule {}
